<div class="relative inline-block text-left mr-2">
  <button [class]="class" class="flex items-center justify-end"
    (mousedown)="toggleDropdown(); $event.stopPropagation()">
    <ng-content select="[multi-select-icon]"></ng-content>
  </button>


  <div *ngIf="showDropdown" [ngStyle]="{'width': boxSize ? boxSize + 'px' : '100%'}" style="z-index: 9999;"
    class=" origin-top-right absolute right-6 -mt-6 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-dark-panel">
    <ul class="py-1 border-none">
      <li *ngFor="let option of options; let i = index" (click)="selectOption(option)" [ngClass]="{
            'border border-b border-gray-50 hover:bg-gray-100 dark:bg-dark-panel': i % 2 === 0,
            'bg-white hover:bg-gray-100 hover:bg-gray-100 dark:bg-dark-panel': i % 2 !== 0
          }"
        class="flex items-center px-4 py-2 cursor-pointer border-none transition-colors duration-150 ease-in-out ">
        <span class="ml-2 flex-grow dark:text-gray-100">{{ option[labelKey] }}</span>
        <ng-container *ngTemplateOutlet="extraContentTemplate; context: {$implicit: option}"></ng-container>
      </li>
    </ul>
  </div>
</div>
